var React = require('react');

function UiRightTriangle (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Right Triangle"),React.createElement("polygon",{"points":"0 50, 50 0, 0 0","key":1})]);
}

UiRightTriangle.defaultProps = {"version":"1.1","x":"0px","y":"0px","viewBox":"0 0 50 50"};

module.exports = UiRightTriangle;

UiRightTriangle.default = UiRightTriangle;
